/**
 * 게시판 글 단독 편집 (/adm/board/{code}/post/new · /adm/board/{code}/post/{id}/edit)
 * ($j.Pages.Admin.BoardPostEdit / body data-page-name="BoardPostEdit")
 *
 * 폼 자체는 $j.F.Admin.BoardPostForm — 콜백 없이 init 하면 저장·삭제 뒤 그 게시판 목록으로 간다.
 */
export default class BoardPostEdit {
    initialize() {
        $j.F.Admin.BoardPostForm.init();
    }
}
